<template>
  <div>
    <IncomeList title="所有" />
  </div>
</template>
<script>
import IncomeList from '../IncomeList'
export default {
  components: {
    IncomeList,
  },
}
</script>
